<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="areaId" label="区域">
              <el-select v-model="formData.areaId" placeholder="请选择区域" @change="areaChange">
                <el-option v-for="(item, index) of areaList" :value="item.areaId" :label="item.areaName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="gridId" label="网格">
              <el-select v-model="formData.gridId" placeholder="请选择区域">
                <el-option v-for="(item, index) of gridList" :value="item.gridId" :label="item.gridName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inspectionDate" label="检查日期">
              <el-date-picker v-model="formData.inspectionDate" placeholder="请选择检查日期" type="date" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="finalScore" label="最终结果">
              <el-radio-group v-model="formData.finalScore">
                <el-radio label="2">合格</el-radio>
                <el-radio label="1">基本合格</el-radio>
                <el-radio label="0">不合格</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="evaluation" label="检查评价">
              <el-input type="textarea" v-model="formData.evaluation" placeholder="请输入检查评价"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="itemList" label="检查项">
              <el-table size="mini" stripe border :data="formData.itemList">
                <el-table-column min-width="120" label="检查项" prop="itemName"></el-table-column>
                <el-table-column min-width="120" label="检查结果" prop="result">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`itemList.${$index}.result`" :rules="[{ required: true, message: '请选择检查结果' }]">
                      <el-select v-model="row.result" placeholder="请选择检查结果">
                        <el-option label="合格" value="2"></el-option>
                        <el-option label="基本合格" value="1"></el-option>
                        <el-option label="不合格" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>

                </el-table-column>
                <el-table-column min-width="120" label="检查备注" prop="resultMsg">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`itemList.${$index}.resultMsg`" :rules="[{ required: true, message: '请输入检查备注' }]">
                      <el-input v-model="row.resultMsg" placeholder="请输入检查备注"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column min-width="120" label="检查图片" prop="resultImg">
                  <template v-slot="{ row, $index }">
                    <el-form-item :prop="`itemList.${$index}.resultImg`" :rules="[{ required: true, message: '请上传检查图片' }]">
                      <media-upload :multiple="false" v-model="row.resultImg">
                        <div slot="tip"></div>
                      </media-upload>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'CheckResultAdd',
  data() {
    return {
      areaList: [],
      gridList: [],
      formData: {
        areaId: '', // 区域id
        gridId: '', // 网格id
        inspectionDate: '', // 检查日期
        finalScore: '', // 最终结果 2合格 1基本合格 0不合格
        evaluation: '', // 检查评价
        itemList: [] // 检查项列表
      },
      rules: {
        areaId: [
          { required: true, message: '请选择区域' }
        ],
        gridId: [
          { required: true, message: '请选择网格' }
        ],
        inspectionDate: [
          { required: true, message: '请选择检查日期' }
        ],
        finalScore: [
          { required: true, message: '请选择最终结果' }
        ],
        evaluation: [
          { required: true, message: '请输入检查评价' }
        ],
        itemList: [
          { required: true, type: 'array', message: '请选择检查项' }
        ]
      }
    }
  },
  created() {
    if (this.recordId) {
      this.loadData()
    }
    this.loadAreaList()
  },
  computed: {
    recordId() {
      return this.$route.query.recordId
    }
  },
  methods: {
    loadAreaList() {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByPage).then(res => {
        this.areaList = res.list
      })
    },
    areaChange(areaId) {
      this.formData.gridId = ''
      this.loadGridList(areaId)
      this.loadAreaDetail(areaId)
    },
    loadAreaDetail(areaId) {
      this.$axios.get(this.$apis.wspb.selectPaFactoryAreaByAreaId, { areaId }).then(res => {
        this.formData.itemList = res.itemList.map(item => {
          return {
            itemId: item.itemId,
            itemName: item.itemName,
            result: '', // 检查结果(2合格1基本合格0不合格)
            resultMsg: '', // 检查备注
            resultImg: '' // 检查图片
          }
        })
      })
    },
    loadGridList(areaId) {
      this.$axios.get(this.$apis.wspb.selectPaFactoryGridByPage, { areaId }).then(res => {
        this.gridList = res.list
      })
    },
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaSanitationResultByRecordId, { recordId: this.recordId }).then(res => {
        this.formData = res
        this.loadGridList(res.areaId)
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.wspb.insertPaSanitationResult
        if (this.recordId) {
          url = this.$apis.wspb.updatePaSanitationResult
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
